module.exports = __webpack_public_path__ + "img/public/SiteIcons/siteSettingTooltipIcon.svg?6c7b91d2";